// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tiers-card-container {
  width: 85%;
  max-width: 450px;
  margin: 0 auto; /* Optional: centers the box horizontally */
  margin-top: 20px; /* Optional: adjust for spacing */
}

.tiers-card-top-border {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border: 1px solid #002129;
  background-color: #C0C0C0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  width: 100%;
  margin: 0 auto;
}

.tiers-card-top-border-left-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129;
  text-align: center;
  margin-left: 10px !important;
}

.tiers-card-top-border-right-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129;
  text-align: center;
  margin-right: 10px !important;
}

.tiers-card-bottom-border {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #002129;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 5px; /* Space between Typography components */
  padding: 5px;
  margin: 0 auto;
}

.tiers-card-bottom-border-text {
  color: #002129;
  font-size: 16px !important;
  font-weight: 700 !important;
}

.tiers-card-list {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;
  width: 100%;
  margin: 0 auto;
  padding: 16px;
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
}`, "",{"version":3,"sources":["webpack://./src/components/TiersGames/TiersCard/TiersCard.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,gBAAA;EACA,cAAA,EAAA,2CAAA;EACA,gBAAA,EAAA,iCAAA;AACJ;;AAEA;EACI,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;AACJ;;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AACJ;;AAEA;EACI,8BAAA;EACA,+BAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA,EAAA,wCAAA;EACA,YAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;EACA,0BAAA;EACA,2BAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,+BAAA;EACA,8BAAA;AACJ","sourcesContent":[".tiers-card-container {\n    width: 85%;\n    max-width: 450px;\n    margin: 0 auto; /* Optional: centers the box horizontally */\n    margin-top: 20px; /* Optional: adjust for spacing */;\n}\n\n.tiers-card-top-border {\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    border: 1px solid #002129;\n    background-color: #C0C0C0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px;  // Optional, adjust for spacing\n    width: 100%;\n    margin: 0 auto;\n}\n\n.tiers-card-top-border-left-text {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #002129;\n    text-align: center;\n    margin-left: 10px !important;\n}\n\n.tiers-card-top-border-right-text {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #002129;\n    text-align: center;\n    margin-right: 10px !important;\n}\n\n.tiers-card-bottom-border {\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border: 1px solid #002129;\n    background-color: #fff;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    gap: 5px; /* Space between Typography components */\n    padding: 5px;\n    margin: 0 auto;\n}\n\n.tiers-card-bottom-border-text {\n    color: #002129;\n    font-size: 16px !important;\n    font-weight: 700 !important;\n}\n\n.tiers-card-list {\n    display: flex;\n    flex-direction: column;\n    justify-content: left;\n    align-items: left;\n    width: 100%;\n    margin: 0 auto;\n    padding: 16px;\n    border-right: 1px solid #002129;\n    border-left: 1px solid #002129;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
